import { AxiosRequestConfig, AxiosResponse } from "axios";
import { api } from "./base/api";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { ITemplateEmailNotificationApi } from "./base/templateEmailNotificationApi";
import {
	DomainBySystemApplicationRequest,
	TemplateEmailNotificationDetailRequest,
	TemplateEmailNotificationUpdateRequest,
} from "../models/request/templateEmailNotificationRequest";
import { TemplateEmailNotificationDetailResultResponse } from "../models/response/templateEmailNotificationResponse";

const baseRoute: string = "TemplateEmailNotification";

export class TemplateEmailNotificationApi extends ITemplateEmailNotificationApi {
	getDomainBySystemApplication(request?: DomainBySystemApplicationRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domainBySystemApplication`, {
			params: request,
		});
	}

	getDetail(
		request: TemplateEmailNotificationDetailRequest,
	): Promise<AxiosResponse<Result<TemplateEmailNotificationDetailResultResponse>>> {
		return api.get(`${baseRoute}/detail`, { params: request });
	}

	update(
		request: TemplateEmailNotificationUpdateRequest,
		config?: AxiosRequestConfig,
	): Promise<AxiosResponse<Result<void>>> {
		return api.put(`${baseRoute}/update`, request, config);
	}
}
